import { setContext } from "@apollo/client/link/context";

/** How long one attempt of an HTTP operation waits for its answer, unless its context sets `timeout` */
export const DEFAULT_TIMEOUT_MS = 15000;

/** Request header telling the backend how long, in milliseconds, this attempt waits before it gives up */
export const CLIENT_TIMEOUT_HEADER = "x-ngp-client-timeout";

/**
 * Sends the timeout of each attempt along, so the backend can stop a query nobody is waiting for any more (TR-5545).
 * Mirrors ApolloLinkTimeout's choice: the operation context's `timeout`, else the default.
 */
export const clientTimeoutLink = setContext((_, { headers, timeout }) => ({
  headers: {
    ...headers,
    [CLIENT_TIMEOUT_HEADER]: String(timeout || DEFAULT_TIMEOUT_MS),
  },
}));
